// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tog_","colBig":"styles_colBig__1jUBt","colSmall":"styles_colSmall__vpB4Q","shopifyNameWrapper":"styles_shopifyNameWrapper__262Y0"};